/* eslint-disable react/no-danger */
import React from "react"
import { createMarkup } from "utils/createMarkup"

import { container } from "./RichTextFlat.css"

type Props = {
  content: string
}

export const RichTextFlat: React.FC<Props> = ({ content }) => {
  return (
    <div
      className={container}
      dangerouslySetInnerHTML={createMarkup(content)}
    />
  )
}
